module.exports = __webpack_public_path__ + "static/img/icon_snb_notice_list_active.7e1324b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_notice_list_active.svg
// module id = q+3p
// module chunks = 10